export default "__VITE_ASSET__2twuM$nb__";